import { BlogRichTextEditor } from "@/app/Blogs/Components/BlogRichTextEditor";
import {
  BlogPreviewIframe,
  type BlogPreviewMetadata,
} from "@/app/Blogs/Components/BlogPreviewIframe";
import { useFormEditState } from "@/lib/Components/Form/Hooks/useFormEditState";

type Props = {
  postId: string;
  metadata: BlogPreviewMetadata;
};

export function BlogPostContentForm({ postId, metadata }: Props) {
  const { isEditing } = useFormEditState();

  const preview = (
    <div className="flex flex-col lg:sticky lg:top-4">
      <label className="mb-2 text-sm font-medium text-zinc-700">
        Live preview
      </label>
      <div className="h-[calc(100vh-10rem)] overflow-hidden rounded-md border border-zinc-200">
        <BlogPreviewIframe metadata={metadata} />
      </div>
    </div>
  );

  if (!isEditing) {
    return <div className="flex flex-col">{preview}</div>;
  }

  return (
    <div className="mx-[calc(50%-50cqw)] grid w-[100cqw] grid-cols-1 items-start gap-4 lg:grid-cols-2">
      {preview}
      <div className="flex flex-col">
        <label className="mb-2 text-sm font-medium text-zinc-700">Editor</label>
        <BlogRichTextEditor postId={postId} />
      </div>
    </div>
  );
}
